import { Component, OnInit, Input } from '@angular/core';
import { CommissionHoldReleaseService } from 'src/app/services/commission-hold-release.service';
import { ModalCommissionHoldReleaseComponent } from 'src/app/shared/modal-commission-hold-release/modal-commission-hold-release.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { CreditHoldReleaseStatus } from 'src/app/model/credit-hold-release-status.model';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';


@Component({
    selector: 'app-retencion-asesor-comision',
    templateUrl: './retencion-asesor-comision.component.html',
    styleUrls: ['./retencion-asesor-comision.component.css']
})
export class RetencionAsesorComisionComponent implements OnInit {

    @Input() catalogoMotivos: any[] = [];
    @Input() figurasRetencion: any[] = [];

    idAsesor: string = '';
    listRetenciones: any[] = [];
    tablesVisible: boolean = false;
    public guardando: boolean = false;
    private itemEditandoIndex: number = -1;
    private tablaInicializada: boolean = false;


    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();

    constructor(
        private commissionHoldReleaseService: CommissionHoldReleaseService,
        private modalService: NgbModal,
        private toastr: ToastrService
    ) { }

    ngOnInit(): void {
        console.log("Inizializando componente de retención de asesor de comisión");
        this.dtOptions = {
            pagingType: 'full_numbers',
            pageLength: 10,
            scrollX: true,
            autoWidth: false,
            language: {
                processing: 'Procesando...',
                search: 'Buscar:',
                lengthMenu: 'Mostrar _MENU_ elementos',
                info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
                infoEmpty: 'Sin elementos.',
                zeroRecords: 'No se encontraron registros',
                emptyTable: 'No hay datos disponibles',
                paginate: {
                    first: 'Primero', previous: 'Anterior',
                    next: 'Siguiente', last: 'Último'
                }
            }
        };
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    getInfoAsesor(idAsesor: string): void {
        if (!idAsesor) return;

        const idFormateado = this.formatAsesorNumber();


        this.commissionHoldReleaseService.validateUsuarioRetencion(idFormateado)
            .subscribe(
                (response) => {
                    if (!response) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'Asesor no encontrado',
                            text: 'No se encontró información para el asesor ' + idFormateado + '. Se abrirá el formulario con datos mínimos para registrar la retención.',
                            timer: 2000,
                            showConfirmButton: false
                        });
                        const asesorMinimo = {
                            vEmployeeId: idFormateado,
                            vNombreEmpleado: 'No encontrado',
                            Empleado: '',
                            Region: '',
                            Estado: '',
                            sucursal: '',
                        };
                        this.idAsesor = '';
                        this.abrirModalRetencionAsesor(asesorMinimo);
                        return;
                    }
                    console.log("Asesor validado para retención de comisión:", response);
                    this.abrirModalRetencionAsesor(response);
                },
                (error) => {
                    console.error('Error al validar retención del asesor:', error);
                    this.toastr.error('Error al consultar el asesor');
                }
            );
    }

    private abrirModalRetencionAsesor(asesor: any): void {
        const modalRef = this.modalService.open(ModalCommissionHoldReleaseComponent, {
            centered: true, size: 'xl', backdrop: 'static'
        });
        modalRef.componentInstance.asesor = asesor;
        modalRef.componentInstance.componente = 'retencion-asesor-comision';
        modalRef.componentInstance.catalogoMotivos = this.catalogoMotivos;
        modalRef.componentInstance.figurasRetencion = this.figurasRetencion;

        modalRef.result.then(
            () => { this.idAsesor = ''; },
            (resultado) => {
                if (resultado && typeof resultado === 'object' && resultado !== 'failure') {
                    this.listRetenciones = [
                        ...this.listRetenciones,
                        {
                            idAsesor: asesor.vEmployeeId || this.formatAsesorNumber(),
                            nombre: asesor.vNombreEmpleado || 'No encontrado',
                            tipoAsesor: asesor.Empleado || '',
                            region: asesor.Region || '',
                            estado: asesor.Estado || '',
                            sucursal: asesor.sucursal || '',
                            motivoDescuento: resultado.motivoDescuento,
                            figuraRetencion: resultado.figuraRetencion,
                            comentarios: resultado.comentarios,
                            porcentageDescontar: resultado.porcentageDescontar,
                            montoRetener: resultado.montoRetener,
                        }
                    ];
                    this.renderTabla(false);
                    this.toastr.success('Retención agregada correctamente');
                }
                this.idAsesor = '';
            }
        );
    }

    guardarRetenciones(): void {
        if (this.listRetenciones.length === 0) return;

        Swal.fire({
            icon: 'question',
            title: 'Confirmar retenciones',
            text: `Se procesarán ${this.listRetenciones.length} retención(es). ¿Deseas continuar?`,
            showCancelButton: true,
            confirmButtonText: 'Sí, guardar',
            cancelButtonText: 'Cancelar'
        }).then(result => {
            if (!result.isConfirmed) return;

            this.guardando = true;

            const payload = this.listRetenciones.map(r => ({
                idAsesor: r.idAsesor,
                idTipoMovimiento: 3,
                userRoleId: localStorage.getItem('com_role') || '',
                userAppId: Number(localStorage.getItem('com_employeeId')) || 0,
                userAppName: localStorage.getItem('com_userName') || '',
                motivoDescuento: r.motivoDescuento,
                figuraRetencion: r.figuraRetencion,
                comentarios: r.comentarios,
                porcentageDescontar: Number(r.porcentageDescontar) || 0,
                vEmployeeId: Number(localStorage.getItem('com_employeeId')) || 0,
                montoComisionTotal: Number(r.montoRetener) || 0,
            }));

            this.commissionHoldReleaseService.guardarRetencionPorAsesor(payload)
                .subscribe({
                    next: (resp) => {
                        this.guardando = false;
                        Swal.fire({
                            icon: 'success',
                            title: '¡Guardado exitoso!',
                            text: 'Las retenciones fueron procesadas correctamente.',
                            confirmButtonText: 'Aceptar'
                        }).then(() => {
                            this.listRetenciones = [];
                            this.tablesVisible = false;
                            this.idAsesor = '';
                        });
                    },
                    error: (err) => {
                        this.guardando = false;
                        console.error('Error al guardar retenciones por asesor:', err);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al guardar',
                            text: 'Ocurrió un error al procesar las retenciones. Intenta de nuevo.',
                            confirmButtonText: 'Aceptar'
                        });
                    }
                });
        });
    }

    eliminarRetencion(item: any): void {
        Swal.fire({
            icon: 'warning',
            title: '¿Eliminar retención?',
            text: 'Se eliminará la retención del asesor ' + item.idAsesor,
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#d33'
        }).then(result => {
            if (result.isConfirmed) {
                this.listRetenciones = this.listRetenciones
                    .filter(r => r !== item);
                if (this.listRetenciones.length === 0) {
                    this.tablesVisible = false;
                } else {
                    this.renderTabla();
                }
            }
        });
    }

    editarRetencion(item: any): void {
        console.log("Editando retención del asesor:", item);
        this.itemEditandoIndex = this.listRetenciones.indexOf(item);
        this.abrirModalEdicionAsesor(item);
    }

    private abrirModalEdicionAsesor(item: any): void {
        const asesor: any = {
            vEmployeeId: item.idAsesor,
            vNombreEmpleado: item.nombre,
            Empleado: item.tipoAsesor,
            Region: item.region,
            Estado: item.estado,
            sucursal: item.sucursal,
            // ← Pre-llenar los campos del modal con los valores actuales
            motivoDescuento: item.motivoDescuento,
            figuraRetencion: item.figuraRetencion,
            comentarios: item.comentarios,
            porcentageDescontar: item.porcentageDescontar,
            montoRetener: item.montoRetener,
        };

        const modalRef = this.modalService.open(ModalCommissionHoldReleaseComponent, {
            centered: true, size: 'xl', backdrop: 'static'
        });
        modalRef.componentInstance.asesor = asesor;
        modalRef.componentInstance.componente = 'retencion-asesor-comision';
        modalRef.componentInstance.catalogoMotivos = this.catalogoMotivos;
        modalRef.componentInstance.figurasRetencion = this.figurasRetencion;

        modalRef.result.then(
            () => { this.itemEditandoIndex = -1; },
            (resultado) => {
                if (resultado && typeof resultado === 'object' && resultado !== 'failure') {
                    if (this.itemEditandoIndex >= 0) {
                        // ← Reemplazar el item existente en lugar de agregar uno nuevo
                        const retencionesCopy = [...this.listRetenciones];
                        retencionesCopy[this.itemEditandoIndex] = {
                            ...retencionesCopy[this.itemEditandoIndex],
                            motivoDescuento: resultado.motivoDescuento,
                            figuraRetencion: resultado.figuraRetencion,
                            comentarios: resultado.comentarios,
                            porcentageDescontar: resultado.porcentageDescontar,
                            montoRetener: resultado.montoRetener,
                        };
                        this.listRetenciones = retencionesCopy;
                        this.renderTabla();
                        this.toastr.success('Retención actualizada correctamente');
                    }
                }
                this.itemEditandoIndex = -1;
            }
        );
    }

    private renderTabla(esEdicion: boolean = false): void {
        if (esEdicion && this.tablaInicializada) {
            // ← Solo actualizar el array, Angular re-renderiza el *ngFor
            this.listRetenciones = [...this.listRetenciones];
            return;
        }

        // ← Render completo: destruir tabla actual y recrear
        this.tablesVisible = false;
        this.tablaInicializada = false;

        // ← Destruir Subject anterior de forma segura
        try {
            if (!this.dtTrigger.closed) {
                this.dtTrigger.unsubscribe();
            }
        } catch (e) { }

        // ← Crear Subject nuevo siempre
        this.dtTrigger = new Subject<any>();

        setTimeout(() => {
            this.tablesVisible = true;

            setTimeout(() => {
                if (this.listRetenciones.length > 0) {
                    try {
                        this.dtTrigger.next(null);
                        this.tablaInicializada = true;
                    } catch (e) {
                        console.warn('dtTrigger error:', e);
                        // ← Reintentar con Subject nuevo
                        this.dtTrigger = new Subject<any>();
                        this.dtTrigger.next(null);
                        this.tablaInicializada = true;
                    }
                }
            }, 200);
        }, 150);
    }

    formatAsesorNumber(): string {
        if (!this.idAsesor || !this.idAsesor.trim()) return '';
        return this.idAsesor.replace(/\s+/g, '').toUpperCase().padStart(5, '0');
    }
}